import { numberToHex } from 'viem';
/** Synchronize wagmi and WalletConnect's approved-chain bookkeeping after verification. */
export async function confirmConnectorChain(connector, chainId) {
    connector.onChainChanged(numberToHex(chainId));
    const walletConnect = connector;
    if (walletConnect.getRequestedChainsIds && walletConnect.setRequestedChainsIds) {
        const ids = await walletConnect.getRequestedChainsIds();
        if (!ids.includes(chainId))
            await walletConnect.setRequestedChainsIds([...ids, chainId]);
    }
}
